var $ = require('jquery');


// TODO: move all these up ...
// Keyboard events: mousestrap and bbplugin to dele. events

module.exports = {

    keyboardEvents: {
        'down'      : 'keyScroll',
        'up'        : 'keyScroll',
        'left'      : 'keyScroll',
        'right'     : 'keyScroll',
        'pageup'    : 'pageKeyCB',
        'pagedown'  : 'pageKeyCB',
        'end'       : 'pageKeyCB',
        'home'      : 'pageKeyCB'
    },

    pageKeyCB: function(e, key) {

        var vCh = this.options.vChannel;

        switch(key) {

            case 'pageup':
                vCh.command('goPrevPage');
                break;

            case 'pagedown':
                vCh.command('goNextPage');
                break;

            case 'end':
                vCh.command('goToLastPage');
                break;

            case 'home':
                vCh.command('goToFirstPage');
                break;

            default:
                return;

        }
    },

    //TODO: move up aand catch at the viewer level, component level prior to firing ...
    keyScroll: function(e, key) { 

        var threshold = 40,
            $el = this.$el,
            x = this.$el.scrollLeft(),
            y = this.$el.scrollTop(),
            dy = key === 'down' ? y + threshold: y - threshold,
            dx = key === 'right' ? x + threshold: x - threshold;

        $el.scrollTop(dy).scrollLeft(dx);  //optimize needed? ... prob not

    },

    // Now only returns el, the inner div is no longer used ( and no longer passes the jq elements )
    getElsForScaleCalc: function() {
        return {
            outerDiv: this.el
        };
    }


};



/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/viewModes/baseModeContainer.js
 ** module id = 415
 ** module chunks = 0
 **/